import { createContext, useContext } from 'react'
import { segmentService } from '../services/segmentService'
import { authService } from '../services/authService'
import { companyService } from '../services/companyService'
import { AuthStore } from './authStore'
import { SegmentStore } from './segmentStore'
import { CompanyStore } from './companyStore'
import { AppStore } from './appStore'
import { AdminStore } from './adminStore'
import { adminService } from '../services/adminService'
import { InsightsStore } from './insightsStore'
import { insightsService } from '../services/insightsService'
import { PricingStore } from './pricingStore'
import { pricingService } from '../services/pricingService'
import { LocalStore } from './localStore'
import { EventStore } from './eventStore'
import { eventService } from '../services/eventService'
import { AudienceLiftConversionStore } from './audienceLiftConversionStore'
import { audienceLiftConversionService } from '../services/audienceLiftConversionService'

export class RootStore {
    authStore: AuthStore
    insightsStore: InsightsStore
    segmentStore: SegmentStore
    appStore: AppStore
    companyStore: CompanyStore
    adminStore: AdminStore
    pricingStore: PricingStore
    localStore: LocalStore
    eventStore: EventStore
    audienceLiftConversionStore: AudienceLiftConversionStore

    constructor() {
        this.adminStore = new AdminStore(this, adminService)
        this.authStore = new AuthStore(this, authService)
        this.insightsStore = new InsightsStore(this, insightsService)
        this.segmentStore = new SegmentStore(this, segmentService, insightsService)
        this.companyStore = new CompanyStore(this, companyService)
        this.pricingStore = new PricingStore(this, pricingService)
        this.appStore = new AppStore()
        this.localStore = new LocalStore(this)
        this.eventStore = new EventStore(this, eventService)
        this.audienceLiftConversionStore = new AudienceLiftConversionStore(this, audienceLiftConversionService)
    }
}

export const RootContext = createContext<RootStore>(null)

export const useRootStore = () => useContext(RootContext)

export const rootStore = new RootStore()
